import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuBar from "../MenuBar";
import { apiFetch } from "../api";

import { useI18n } from "../i18n/I18nContext";

export default function ConsultationQualiteBois() {
  const { t, ui } = useI18n();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const [details, setDetails] = useState(null);

  /* ---------------------------------------------------------
     🔥 SAFE JSON PARSE
  --------------------------------------------------------- */
  const safeParse = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    try {
      return JSON.parse(val);
    } catch {
      return [];
    }
  };

  /* ---------------------------------------------------------
     🔥 LOAD DATA
  --------------------------------------------------------- */
  useEffect(() => {
    (async () => {
      try {
        const r = await apiFetch("/api/qualite/mpbois/list");
        const j = await r.json();
        console.log("DATA REÇUE :", j);

        const cleaned = (j.items || j || []).map((item) => ({
          ...item,
          Samples: safeParse(item.Samples),
          SamplesComments: safeParse(item.SamplesComments),
        }));

        setRows(cleaned);
        setLoading(false);
      } catch (e) {
        console.error(e);
        setErr("Erreur de chargement");
        setLoading(false);
      }
    })();
  }, []);

  /* ---------------------------------------------------------
     🔍 SEARCH FILTER
  --------------------------------------------------------- */
  const filtered = rows.filter((r) => {
    const s = search.toLowerCase();
    return (
      r.Operator?.toLowerCase().includes(s) ||
      r.Fournisseur?.toLowerCase().includes(s) ||
      r.LotFournisseur?.toLowerCase().includes(s)
    );
  });

  /* ---------------------------------------------------------
     🎨 RENDER UI
  --------------------------------------------------------- */
  return (
    <div style={styles.page}>
      <MenuBar active="qualite" />

      <div style={styles.wrap}>
        <section style={styles.panel}>
          <div style={styles.panelTitle}>CONSULTATION – QUALITÉ MP (BOIS)</div>

          <input
            placeholder="Recherche par opérateur, fournisseur ou lot..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={styles.search}
          />

          {loading && <div style={{ color: "#fff" }}>{ui("Chargement…")}</div>}
          {err && <div style={{ color: "red" }}>{err}</div>}

          {!loading && (
            <div style={styles.tableContainer}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Fournisseur</th>
                    <th>Lot</th>
                    <th>Opérateur</th>
                    <th>Bois</th>
                    <th>NOK</th>
                    <th>Détails</th>
                    <th>{ui("Modifier")}</th>
                  </tr>
                </thead>

                <tbody>
                  {filtered.map((row) => (
                    <tr key={row.index}>
                      <td>{row.index}</td>
                      <td>{row.Date}</td>
                      <td>{row.Fournisseur}</td>
                      <td>{row.LotFournisseur}</td>
                      <td>{row.Operator}</td>
                      <td>{row.QuantiteBois}</td>

                      <td
                        style={{
                          fontWeight: 700,
                          color:
                            Number(row.PliesNOK) > 0 ? "#ff4d4d" : "#00c853",
                        }}
                      >
                        {row.PliesNOK || 0}
                      </td>

                      <td>
                        <button
                          style={styles.btn}
                          onClick={() => setDetails(row)}
                        >
                          Voir
                        </button>
                      </td>

                      <td>
                        <button
                          style={styles.btn}
                          onClick={() =>
                            navigate("/qualite/mpar/form", {
                              state: { item: row },
                            })
                          }
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>

        {/* -----------------------------------------------------
           DETAILS MODAL
        ----------------------------------------------------- */}
        {details && (
          <div style={styles.modalBackdrop}>
            <div style={styles.modal}>
              <div style={styles.modalTitle}>
                📌 Détails du lot #{details.LotFournisseur} fournisseur{" "}
                {details.Fournisseur}
              </div>

              {/* MESURES TECHNIQUES */}
              <div style={styles.subTitle}>Mesures Techniques</div>

              <table style={styles.detailTable}>
                <thead>
                  <tr>
                    <th>Sample</th>
                    <th>Grade</th>
                    <th>Humidité</th>
                    <th>Moisissure</th>
                    <th>Autre</th>
                  </tr>
                </thead>

                <tbody>
                  {details.Samples?.map((s, i) => (
                    <tr key={i}>
                      <td>{s.sample}</td>
                      <td>{s.grade}</td>
                      <td>{s.humidite}</td>
                      <td>{s.moisissure}</td>
                      <td>{s.autre}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* COMMENTAIRES SI NOK */}
              {Number(details.PliesNOK) > 0 && (
                <>
                  <div style={styles.subTitle}>Samples / Commentaires</div>

                  <table style={styles.detailTable}>
                    <thead>
                      <tr>
                        <th>Sample</th>
                        <th>Commentaire</th>
                      </tr>
                    </thead>

                    <tbody>
                      {details.SamplesComments?.map((c, i) => (
                        <tr key={i}>
                          <td>{c.sample}</td>
                          <td>{c.commentaire}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}

              <button style={styles.closeBtn} onClick={() => setDetails(null)}>
                FERMER
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ---------------------------------------------------------
   🌈 STYLES SUPER BEAUX & MODERNES
--------------------------------------------------------- */

const styles = {
  page: { background: "#0d1117", minHeight: "100vh", color: "#fff" },

  wrap: { padding: "20px" },

  panel: {
    background: "#161b22",
    padding: 25,
    borderRadius: 12,
    border: "1px solid #30363d",
    boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
  },

  panelTitle: {
    fontSize: 22,
    fontWeight: 900,
    marginBottom: 15,
    textAlign: "center",
    letterSpacing: 1,
  },

  search: {
    width: "100%",
    marginBottom: 15,
    padding: 10,
    borderRadius: 8,
    border: "1px solid #30363d",
    background: "#0d1117",
    color: "#fff",
    fontSize: 15,
    textAlign: "center",
  },

  /* TABLE DESIGN */
  tableContainer: {
    borderRadius: 12,
    overflow: "hidden",
    border: "1px solid #30363d",
    boxShadow: "0 3px 10px rgba(0,0,0,0.35)",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    background: "#1c2128",
    color: "#fff",
    textAlign: "center",
  },

  btn: {
    padding: "6px 12px",
    borderRadius: 6,
    cursor: "pointer",
    border: "1px solid #555",
    background: "#E6FF3E",
    fontWeight: 700,
  },

  /* MODAL DESIGN */
  modalBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    zIndex: 100,
  },

  modal: {
    background: "#ffffff",
    color: "#000",
    borderRadius: 12,
    padding: 25,
    width: "90%",
    maxWidth: 780,
    boxShadow: "0 5px 20px rgba(0,0,0,0.3)",
  },

  modalTitle: {
    fontSize: 20,
    fontWeight: 900,
    marginBottom: 18,
    textAlign: "center",
  },

  subTitle: {
    marginTop: 20,
    marginBottom: 10,
    fontWeight: 800,
    fontSize: 16,
  },

  detailTable: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 20,
    textAlign: "center",
    border: "1px solid #ddd",
  },

  closeBtn: {
    padding: "12px 20px",
    fontWeight: 900,
    background: "#E6FF3E",
    borderRadius: 8,
    cursor: "pointer",
    width: "100%",
    marginTop: 10,
  },
};
